import { ReactNode } from 'react';

import { tabsVariants } from './variants';
import { CustomersStepTypeEnumPaths } from '@/shared/endpoints/customers';

interface ITabOption<TValue> {
    name: ReactNode;
    path: TValue;
    disabled?: boolean;
}

interface IProps<TValue> {
    className?: string;
    tabRef: React.RefObject<HTMLDivElement>;
    tabClassName?: string;
    options: ITabOption<TValue>[];
    value?: TValue;
    onChange?(selectedOption: ITabOption<TValue>, selectedIndex: number): void;
    variant?: 'primary' | 'secondary';
}

const TabsBtnsBgColors = {
    [CustomersStepTypeEnumPaths.ABOUT_YOU]: '#FCFAF8',
    [CustomersStepTypeEnumPaths.INSURANCE]: '#FAFAFC',
    [CustomersStepTypeEnumPaths.PRESCRIPTIONS]: ' #FAFCFB',
    [CustomersStepTypeEnumPaths.REVIEW]: '#FAFCFB'
};

export const Tabs = <TValue extends string | number>({
    className,
    tabClassName,
    options,
    value,
    onChange,
    variant = 'primary',
    tabRef
}: IProps<TValue>) => {
    return (
        <div
            ref={tabRef}
            className={`tabs-wrapper ${tabsVariants[variant].tabsWrapper} ${className || ''}`}
            style={{
                background: TabsBtnsBgColors[value as typeof CustomersStepTypeEnumPaths.ABOUT_YOU]
            }}
        >
            {options.map((option, optionIndex) => (
                <button
                    key={option.path}
                    type="button"
                    data-testid={`button-tab-${optionIndex}`}
                    onClick={() => onChange?.(option, optionIndex)}
                    disabled={option.disabled}
                    className={`
                    ${option.path === value
                            ? `tab-selected ${tabsVariants[variant].tabSelected} !text-primary-700`
                            : tabsVariants[variant].tab + ' sm:text-grey-700 text-grey-500'
                        } ${tabClassName || ''}  font-dmSans font-semibold
                    `}
                >
                    {option.name}
                </button>
            ))}
        </div>
    );
};

export default Tabs;
